export default __webpack_public_path__ + "static/money-spent-christmas-b57b6599250293a5f7daaa893b4c8728.png";